import {IsInt, IsOptional, IsString} from 'class-validator';

export class DeactivateUserDto {
  @IsInt()
  reason!: number;

  @IsString()
  password!: string;

  @IsOptional()
  @IsString()
  description?: string | null;
}
